export default ({request}) =>({
    masSupplierListApi(data = {}){
        return request({
            url: '/master/master/supplier/list',
            method:'post',
            data,
        })
    },
    masSupplierSaveApi(data = {}){
        return request({
            url: '/master/master/supplier/save',
            method:'post',
            data,
        })
    },
    masSupplierDetailApi(data = {}){
        return request({
            url: '/master/master/supplier/detail',
            method:'post',
            data,
        })
    },
    masSupplierDelApi(data = {}) {
        return request({
          url: '/master/master/supplier/del',
          method: 'post',
          data,
        })
    },
})